/* eslint-disable max-len */
import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import {
  Menu, MenuItem, Sidebar, SubMenu, useProSidebar,
} from 'react-pro-sidebar';
import { useSelector, useDispatch } from 'react-redux';
import { Badge, Tooltip } from '@mui/material';
import taiLogo from '../../assets/tailogo-eddyCurrent.png';
import taiLogoWhite from '../../assets/taiLogoWhite.png';
import taiHalfLogo from '../../assets/taihhalflogo.svg';
import addCustomerIcon from '../../assets/Icons/addCustomerIcon.svg';
import addJobIcon from '../../assets/Icons/addJobIcon.svg';
import { NotificationIcon, SidebarClosedIcon, SidebarOpenIcon } from '../../assets/NavBarIcons';
import './StyleNotification.scss';
import { ScreenProfile } from './ScreenProfile';
import { RootState } from '../../redux/rootState';
import { getSidebarStyles, getUserProfileStart, setMySidebarStyles } from '../Profile/Redux/sliceMyProfile';
import menuItems from './ScreenSidebarMenu';
import { getMasterDataStart } from '../../redux/masters/masterSlice';
import { Empty } from '../ScreenAddSmc/Utils/TypeSmc';
import localStorageConstants, { sessionStorageConstants } from '../../utils/LocalStorageConstants';
import { ADMIN_ROLE_ID, ANALYST_ROLE_ID } from '../../Routes/constant';
import ScreenNotification from './ScreenNotification';
import { DollarIcon } from '../../assets/NavBarIcons/DollarsIcon';
import ScreenExpenseNotification from './ScreenExpenseNotification';
import { getExpenseNotifications, getFoNotifications, getNotifications } from './redux/dashboardSlice';
import ScreenFoNotification from './ScreenFoNotification';
import { SendEquipmentIcon } from '../../assets/NavBarIcons/SendEquipmentIcon';
import { getTextColorAsPerBackground } from '../../utils/CommonFunctions';
import { defaultSidebarColorDetails } from '../addCustomer/utils/helper';

export function ScreenSidebar() {
  const dispatch = useDispatch();
  const { collapseSidebar, collapsed } = useProSidebar();
  const [mobileMenu, setMobileMenu] = useState(false);
  const { userProfile, mySidebarStyles, sidebarStylesData } = useSelector((state: RootState) => state.userProfileReducer);
  const { expenseNotifications, notifications, foNotifications } = useSelector((state: RootState) => state.dashboardReducer);
  const roleId = localStorage.getItem(localStorageConstants.ROLE_ID);
  const hideSidebar = () => {
    setMobileMenu(false);
    sessionStorage.removeItem(sessionStorageConstants.SubMenuKeyID);
  };

  useEffect(() => {
    if (Object.keys(sidebarStylesData)?.length > 0) {
      let sidebarImageSet = mySidebarStyles.imageSet;

      if (sidebarStylesData?.IsDark !== undefined) {
        sidebarImageSet = sidebarStylesData.IsDark ? 'black' : 'white';
      }

      dispatch(setMySidebarStyles({
        textColor: sidebarStylesData?.TextColor,
        backgroundColor: sidebarStylesData?.BackgroundColor,
        secondBackgroundColor: sidebarStylesData?.SecondBackgroundColor,
        selectedBackgroundColor: sidebarStylesData?.SelectionColor,
        imageSet: sidebarImageSet,
      }));
    }
  }, [sidebarStylesData]);

  // const sidebarActiveIconColor = '#ffffff';
  // const hoverTextColor = '#ffffff';
  const sidebarActiveIconColor = getTextColorAsPerBackground(mySidebarStyles?.selectedBackgroundColor || '') === 'white' ? '#ffffff' : '#000000';
  const hoverTextColor = getTextColorAsPerBackground(mySidebarStyles?.selectedBackgroundColor || '') === 'white' ? '#ffffff' : '#000000';
  const sidebarIconColor = mySidebarStyles.imageSet === 'black' ? '#363636' : '#ffffff';
  const borderThemeColor = 'none';
  // const borderThemeColor = mySidebarStyles.imageSet === 'black' ? '#c1bfbf' : 'none';
  const treeThemeColor = mySidebarStyles.imageSet === 'black' ? '#363636' : '#ffffff';
  const sidebarMainMenuItemColor = mySidebarStyles.secondBackgroundColor;
  const sidebarThemeStyle = {
    '--sidebar-text-color': mySidebarStyles.textColor,
    '--sidebar-background-color': mySidebarStyles.backgroundColor,
    '--sidebar-main-menu-item-background-color': sidebarMainMenuItemColor,
    '--sidebar-hover-background-color': mySidebarStyles.selectedBackgroundColor,
    '--sidebar-selected-background-color': mySidebarStyles.selectedBackgroundColor,
    '--sidebar-hover-text-color': hoverTextColor,
    '--sidebar-icon-color': sidebarIconColor,
    '--sidebar-active-icon-color': sidebarActiveIconColor,
    '--sidebar-border-theme-color': borderThemeColor,
    '--sidebar-tree-theme-color': treeThemeColor,
  } as React.CSSProperties;

  const handleSideBar = () => (
    collapsed
      ? <div className="forDeesktopView" onClick={() => { collapseSidebar(); }}><SidebarOpenIcon /></div>
      : <div className="forDeesktopView" onClick={() => { collapseSidebar(); }}><SidebarClosedIcon /></div>
  );

  const handleSideBarOnMob = () => (
    mobileMenu
      ? <div className="forMobileView" onClick={() => { setMobileMenu(false); }}><SidebarClosedIcon /></div>
      : <div className="forMobileView" onClick={() => { setMobileMenu(true); }}><SidebarOpenIcon /></div>
  );

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isFoNotificationOpen, setIsFoNotificationOpen] = useState(false);
  const [isExpenseNotificationOpen, setIsExpenseNotificationOpen] = useState(false);
  const [sidebarMenuKey, setSidebarMenuKey] = useState(0);
  const menuRef = useRef<HTMLDivElement>(null);
  const notificationRef = useRef<HTMLDivElement>(null);
  const foNotificationRef = useRef<HTMLDivElement>(null);
  const exNotificationRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (roleId === String(ADMIN_ROLE_ID)) {
      const pay = {
        PageNumber: 1,
        PageSize: 10,
      };
      dispatch(getExpenseNotifications(pay));
      dispatch(getNotifications({ ...pay, IsSendNotification: true }));
      dispatch(getFoNotifications({ ...pay, IsFoNotification: true }));
    }
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target as Node)) {
        setIsNotificationOpen(false);
      }
      if (foNotificationRef.current && !foNotificationRef.current.contains(event.target as Node)) {
        setIsFoNotificationOpen(false);
      }
      if (exNotificationRef.current && !exNotificationRef.current.contains(event.target as Node)) {
        setIsExpenseNotificationOpen(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    dispatch(setMySidebarStyles({
      textColor: defaultSidebarColorDetails.textColor,
      backgroundColor: defaultSidebarColorDetails.backgroundColor,
      secondBackgroundColor: defaultSidebarColorDetails.secondBackgroundColor,
      selectedBackgroundColor: defaultSidebarColorDetails.selectedBackgroundColor,
      imageSet: defaultSidebarColorDetails.imageSet,
    }));
    dispatch(getUserProfileStart());
    dispatch(getSidebarStyles());
  }, []);

  const getFirstLetter = (inputString: string) => inputString.charAt(0);
  const firstLetter = getFirstLetter(userProfile?.FirstName ? userProfile?.FirstName : '');
  const secondLetter = getFirstLetter(userProfile?.LastName ? userProfile?.LastName : '');

  const [openTooltip, setOpenTooltip] = React.useState(0);
  const handleCloseTooltip = () => {
    setOpenTooltip(0);
  };

  const handleOpenTooltip = (itemId: number) => {
    if (collapsed) {
      setOpenTooltip(itemId);
    } else {
      setOpenTooltip(0);
    }
  };

  const fetchMasterData = () => {
    dispatch(getMasterDataStart());
  };

  useEffect(() => {
    fetchMasterData();
  }, []);

  const handleSubmenuClick = (submenuKey: number) => {
    hideSidebar();
    sessionStorage.setItem(sessionStorageConstants.SubMenuKeyID, String(submenuKey));
  };

  const activeSubmenu = useMemo(
    () => Number(sessionStorage.getItem(sessionStorageConstants.SubMenuKeyID)),
    [handleSubmenuClick],
  );

  const closeCollapsedMenuPopup = () => {
    if (collapsed) {
      setSidebarMenuKey((currentKey) => currentKey + 1);
    }
  };

  const handleMenuItemClick = (submenuKey?: number) => {
    if (submenuKey !== undefined) {
      handleSubmenuClick(submenuKey);
      closeCollapsedMenuPopup();
      return;
    }

    hideSidebar();
    closeCollapsedMenuPopup();
  };

  const renderSidebarMenuItem = (menuItem: Empty, parentSubmenuKey?: number, level = 0) => {
    const submenuKey = menuItem.activeSubmenuId ?? parentSubmenuKey;
    const isActiveSubmenu = activeSubmenu === menuItem.activeSubmenuId;
    const menuLevelClassName = level === 0 ? 'sidebarTopLevelMenu' : 'sidebarNestedMenu';
    const menuClassName = `${isActiveSubmenu ? 'SubmenuStyle ' : ''}${menuLevelClassName} sideBarMenu`;
    const key = `${level}-${menuItem.id}-${menuItem.label}`;

    if (menuItem.subMenu) {
      return (
        <SubMenu
          key={key}
          className={menuClassName}
          defaultOpen={isActiveSubmenu}
          label={<span className="margin_3">{menuItem.label}</span>}
          icon={menuItem.icon}
        >
          {menuItem.subMenu
            .filter((subMenuItem: Empty) => subMenuItem?.show !== false)
            .map((subMenuItem: Empty) => renderSidebarMenuItem(subMenuItem, submenuKey, level + 1))}
        </SubMenu>
      );
    }

    return (
      <MenuItem
        key={key}
        className={`${!collapsed && level > 0 ? 'sidebarSubMenuIcon ' : ''}${menuLevelClassName} sideBarMenu`}
        component={<NavLink to={menuItem.link} className="link" />}
        icon={menuItem.icon}
        onClick={() => handleMenuItemClick(parentSubmenuKey)}
      >
        <span className="margin_3">{menuItem.label}</span>
      </MenuItem>
    );
  };

  return (
    <div className="container_div">
      <Sidebar
        className="app tai-sidebar"
        id={mobileMenu ? 'sideBarMenuShow' : 'sideBarMenuHide'}
        style={sidebarThemeStyle}
      >
        <Menu
          key={sidebarMenuKey}
          transitionDuration={500}
          closeOnClick={false}
          menuItemStyles={{
            button: {
              height: '42px',
              margin: '0 5px 6px',
              padding: '0 14px !important',
              color: 'var(--sidebar-text-color)',
              borderRadius: '6px',
              '&.active': {
                backgroundColor: 'var(--sidebar-selected-background-color)',
                color: 'var(--sidebar-hover-text-color)',
              },
              '&:hover': {
                backgroundColor: 'var(--sidebar-hover-background-color)',
                color: 'var(--sidebar-hover-text-color)',
              },
            },
          }}
          className="sideBarMenuClass"
        >
          <MenuItem
            className="menu1"
          >
            <div
              className="img_container_navbar"
            >
              {collapsed ? <NavLink to="/dashboard" className="link"><img src={taiHalfLogo} alt="TAI Logo" height="42px" width="auto" /></NavLink> : <NavLink to="/dashboard" className="link"><img src={getTextColorAsPerBackground(mySidebarStyles?.backgroundColor) === 'white' ? taiLogoWhite : taiLogo} alt="TAI Logo" height="49px" width="180px" /></NavLink>}
            </div>
          </MenuItem>
          {menuItems(roleId || '').map((menuItem: Empty) => {
            if (!menuItem?.show) {
              return null;
            }

            if (menuItem?.roleId && Number(menuItem?.roleId) !== Number(roleId)) {
              return null;
            }

            return (
              <Tooltip
                key={`${menuItem.id}-${menuItem.label}`}
                title={menuItem.label}
                placement="right"
                arrow
                open={collapsed ? (Number(openTooltip) === menuItem.id) : false}
                onClose={handleCloseTooltip}
                onOpen={() => handleOpenTooltip(menuItem.id)}
              >
                {renderSidebarMenuItem(menuItem)}
              </Tooltip>
            );
          })}
        </Menu>
      </Sidebar>
      <div className="sub_div_navbar">
        <div className="inner_div_navBar">
          {handleSideBar()}
          {handleSideBarOnMob()}
          <div className="img_container_navbar">
            {roleId !== ANALYST_ROLE_ID && (
              <>
                <NavLink to="/jobs/add-job" className="link_style">
                  <Tooltip
                    placement="bottom"
                    title="Add Job"
                    arrow
                  >
                    <img src={addJobIcon} alt="add Job" />
                  </Tooltip>
                </NavLink>
                <NavLink to="/customers/add-customer" className="link_style">
                  <Tooltip
                    placement="bottom"
                    title="Add Customer"
                    arrow
                  >
                    <img src={addCustomerIcon} alt="add Customer" />
                  </Tooltip>
                </NavLink>
              </>
            )}
            {roleId === String(ADMIN_ROLE_ID) && (
            <div className="relative_div" ref={notificationRef}>
              <div className="dropdown">
                <Badge badgeContent={notifications?.TotalRecords || 0} color="error" className="customNotificationIcon" onClick={() => setIsNotificationOpen(!isNotificationOpen)}>
                  <SendEquipmentIcon />
                </Badge>
              </div>
              {
                isNotificationOpen
                && (
                  <div className="menu">
                    <ScreenNotification handleClose={() => setIsNotificationOpen(false)} />
                  </div>
                )
              }
            </div>
            )}
            {roleId === String(ADMIN_ROLE_ID) && (
            <div className="relative_div" ref={foNotificationRef}>
              <div className="dropdown">
                <Badge badgeContent={foNotifications?.TotalRecords || 0} color="error" className="customNotificationIcon" onClick={() => setIsFoNotificationOpen(!isFoNotificationOpen)}>
                  <NotificationIcon />
                </Badge>
              </div>
              {
                isFoNotificationOpen
                && (
                  <div className="menu">
                    <ScreenFoNotification handleClose={() => setIsFoNotificationOpen(false)} />
                  </div>
                )
              }
            </div>
            )}
            {roleId === String(ADMIN_ROLE_ID) && (
            <div className="relative_div" ref={exNotificationRef}>
              <div className="dropdown">
                <Badge badgeContent={expenseNotifications?.TotalCount || 0} color="error" className="customNotificationIcon" onClick={() => setIsExpenseNotificationOpen(!isExpenseNotificationOpen)}>
                  <DollarIcon />
                </Badge>
              </div>
              {
                isExpenseNotificationOpen
                && (
                  <div className="menu">
                    <ScreenExpenseNotification />
                  </div>
                )
              }
            </div>
            )}
            <div className="relative_div" ref={menuRef}>
              <div className="div_inner_header" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                <div className="header_profile_pic ">
                  <span>
                    {firstLetter}
                    {secondLetter}
                  </span>
                </div>
                <div className="fontSize">
                  {userProfile.FirstName}
                </div>
              </div>
              {
                isMenuOpen
                && (
                  <div className="menu">
                    <ScreenProfile />
                  </div>
                )
              }
            </div>
          </div>
        </div>
        <section className="section_Style">
          <Outlet />
        </section>
      </div>
    </div>
  );
}
